// 数据报表管理路由
export default {
    path: 'report',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '数据报表'},
    children: [
        {
            path: 'fans',
            component: () => import('@/components/RouterView'),
            redirect: '/report/fans/newFans',
            meta: {title: '用户统计'},
            children: [
                {
                    path: 'newFans',
                    component: () => import('@/views/report/fans/newFans'),
                    meta: {title: '新增乐迷'}
                },
                {
                    path: 'loginFans',
                    component: () => import('@/views/report/fans/loginFans'),
                    meta: {title: '登录用户'}
                },
            ]
        },		
        {
            path: 'sales',
            component: () => import('@/components/RouterView'),
            redirect: '/report/sales/city',
            meta: {title: '销售统计'},
            children: [
                {
                    path: 'city',
                    component: () => import('@/views/report/sales/city/list'),
                    meta: {title: '城市销售', cache: true},
                },
                {
                    path: 'city/date',
                    component: () => import('@/views/report/sales/city/date'),
                    meta: {title: '城市销售日期明细'},
                },
                {
                    path: 'city/style',
                    component: () => import('@/views/report/sales/city/style'),
                    meta: {title: '城市销售风格明细'},
                },
                {
                    path: 'site',
                    component: () => import('@/views/report/sales/site/list'),
                    meta: {title: '场地销售', cache: true},
                },
                {
                    path: 'site/date',
                    component: () => import('@/views/report/sales/site/date'),
                    meta: {title: '场地销售日期明细'},
                },
                {
                    path: 'artist',
                    component: () => import('@/views/report/sales/artist/list'),
                    meta: {title: '艺人销售', cache: true},
                },
                {
                    path: 'artist/date',
                    component: () => import('@/views/report/sales/artist/date'),
                    meta: {title: '艺人销售日期明细'},
                },
                {
                    path: 'channel',
                    component: () => import('@/views/report/sales/channel/list'),
                    meta: {title: '渠道销售', cache: true},
                },
                {
                    path: 'channel/date',
                    component: () => import('@/views/report/sales/channel/date'),
                    meta: {title: '渠道销售日期明细'},
                },
				{
				    path: 'channel/proportion',
				    component: () => import('@/views/report/sales/channel/proportion'),
				    meta: {title: '渠道销售演出占比'},
				},
                {
                    path: 'show',
                    component: () => import('@/views/report/sales/show/list'),
                    meta: {title: '演出销售', cache: true},
                },
                {
                    path: 'show/date',
                    component: () => import('@/views/report/sales/show/date'),
                    meta: {title: '演出销售日期明细'},
                },
                {
                    path: 'show/chart',
                    component: () => import('@/views/report/sales/show/chart'),
                    meta: {title: '演出销售图表'},
                },
                {
                    path: 'touring',
                    component: () => import('@/views/report/sales/touring/list'),
                    meta: {title: '巡演销售', cache: true},
                },
                {
                    path: 'touring/date',
                    component: () => import('@/views/report/sales/touring/date'),
                    meta: {title: '巡演销售日期明细'},
                },
                {
                    path: 'crowdfunding',
                    component: () => import('@/views/report/sales/crowdfunding/list'),
                    meta: {title: '众筹销售', cache: true},
                },
                {
                    path: 'crowdfunding/date',
                    component: () => import('@/views/report/sales/crowdfunding/date'),
                    meta: {title: '众筹销售日期明细'},
                },
                {
                    path: 'surrounding',
                    component: () => import('@/views/report/sales/surrounding/list'),
                    meta: {title: '周边销售', cache: true},
                },
                {
                    path: 'surrounding/date',
                    component: () => import('@/views/report/sales/surrounding/date'),
                    meta: {title: '周边销售日期明细'},
                },
                {
                    path: 'surrounding/chart',
                    component: () => import('@/views/report/sales/surrounding/chart'),
                    meta: {title: '周边销售图表'},
                },
                {
                    path: 'terminal',
                    component: () => import('@/views/report/sales/terminal/list'),
                    meta: {title: '终端销售', cache: true},
                },{
                    path: 'terminal/date',
                    component: () => import('@/views/report/sales/terminal/date'),
                    meta: {title: '终端销售日期明细'},
                },
				{
				    path: 'service',
				    component: () => import('@/views/report/sales/service/list'),
				    meta: {title: '乐迷服务费', cache: true},
				},
				
            ]
        },
        {
            path: 'hot',
            component: () => import('@/components/RouterView'),
            redirect: '/report/hot/list',
            meta: {title: '热度'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/report/hot/list'),
                    meta: {title: '热度统计'}
                },{
                    path: 'activity/collect',
                    component: () => import('@/views/report/hot/activity/collect'),
                    meta: {title: '演出收藏'}
                },{
                    path: 'raise/collect',
                    component: () => import('@/views/report/hot/raise/collect'),
                    meta: {title: '众筹收藏'}
                },{
                    path: 'live/subscribe',
                    component: () => import('@/views/report/hot/live/subscribe'),
                    meta: {title: '直播预约'}
                },{
                    path: 'live/watch',
                    component: () => import('@/views/report/hot/live/watch'),
                    meta: {title: '直播观看'}
                },{
                    path: 'join/activity',
                    component: () => import('@/views/report/hot/join/activity'),
                    meta: {title: '参加活动'}
                },{
                    path: 'video/play',
                    component: () => import('@/views/report/hot/video/play'),
                    meta: {title: '视频播放'}
                },{
                    path: 'video/praise',
                    component: () => import('@/views/report/hot/video/praise'),
                    meta: {title: '视频点赞'}
                },{
                    path: 'video/comment',
                    component: () => import('@/views/report/hot/video/comment'),
                    meta: {title: '视频评论'}
                },
            ]
        },
        {
            path: 'channel',
            component: () => import('@/components/RouterView'),
            redirect: '/report/channel/channelReport/reportList',
            meta: {title: '渠道跟踪'},
            children: [
                {
                    path: 'channelReport/reportList',
                    component: () => import('@/views/report/channel/channelReport/reportList'),
                    meta: {title: '数据汇总'}
                },
                {
                    path: 'channelReport/channelDataList/:id',
                    component: () => import('@/views/report/channel/channelReport/channelDataList'),
                    meta: {title: '跟踪对象明细'},
                    props: true
                },
                {
                    path: 'channelReport/channelTimeList/:channelId/:objectId',
                    component: () => import('@/views/report/channel/channelReport/channelTimeList'),
                    meta: {title: '日期明细'},
                    props: true
                },
                {
                    path: 'accessDetails/list',
                    component: () => import('@/views/report/channel/accessDetails/list'),
                    meta: {title: '访问明细'}
                },
                {
                    path: 'channelList',
                    component: () => import('@/views/report/channel/channelList'),
                    meta: {title: '渠道列表'}
                },
				{
				    path: 'channelTrack',
				    component: () => import('@/views/report/channel/channelTrack'),
				    meta: {title: '渠道跟踪'}
				},
				{
				    path: 'channelReport/linkList',
				    component: () => import('@/views/report/channel/channelReport/linkList'),
				    meta: {title: '快链数据'}
				},
            ]
        }
    ]
};
